'use strict';
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.ifDeployedAndProduction = undefined;

var _enviro = require('enviro');

var _enviro2 = _interopRequireDefault(_enviro);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var ifDeployedAndProduction = exports.ifDeployedAndProduction = function ifDeployedAndProduction(service) {
  return _enviro2.default.deployed(service) && _enviro2.default.getShort(service) === 'prod';
};


//////////////////
// WEBPACK FOOTER
// /usr/share/hubspot/build/.hubspot/static-archive/q/static-4.11/js/util/env.js
// module id = 416
// module chunks = 0